import { Search, X } from "lucide-react"
import type { ReactNode } from "react"

import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { cn } from "@/lib/utils"

interface FilterToolbarProps {
  search: string
  onSearchChange: (value: string) => void
  searchPlaceholder?: string
  children?: ReactNode
  activeFilterCount?: number
  onReset?: () => void
  resetLabel?: string
  className?: string
}

export function FilterToolbar({
  search,
  onSearchChange,
  searchPlaceholder,
  children,
  activeFilterCount = 0,
  onReset,
  resetLabel,
  className,
}: FilterToolbarProps) {
  const hasActiveFilters = activeFilterCount > 0
  return (
    <div
      className={cn(
        "flex flex-col gap-2 sm:flex-row sm:items-center",
        className,
      )}
    >
      <div className="relative flex-1">
        <Search className="text-muted-foreground pointer-events-none absolute top-1/2 left-3 size-4 -translate-y-1/2" />
        <Input
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={searchPlaceholder}
          className="h-10 pl-9"
        />
      </div>

      {children ? (
        <div className="flex flex-wrap items-center gap-2">{children}</div>
      ) : null}

      {hasActiveFilters && onReset ? (
        <Button
          type="button"
          size="sm"
          variant="ghost"
          onClick={onReset}
          className="text-muted-foreground hover:text-foreground h-10 gap-1.5"
        >
          <X className="size-4" />
          <span className="text-xs">
            {resetLabel}
            <span className="bg-primary/10 text-primary ml-1.5 inline-flex h-4 min-w-4 items-center justify-center rounded-full px-1 text-[10px] font-semibold tabular-nums">
              {activeFilterCount}
            </span>
          </span>
        </Button>
      ) : null}
    </div>
  )
}
